<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn 
          icon 
          v-on="on"
        >
          <v-icon color="primary">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    
      <material-card
        :offset="10"
        :full-width="true"
        color="hrissecondary"
        title="Nett Pay"
        text="Update Nett Pay"
        class="mb-0"
        :loading="loading"
      >
        <form v-if="dialog && !loading">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="localNettPay.current_cycle_net_salary" 
                  v-money="money"
                  label="Nett Pay"
                  prefix="RM"
                  outlined
                />    
              </v-col>
            </v-row>
          </v-container>
        </form> 

        <v-card-actions v-if="dialog && !loading">
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"    
            class="white--text px-10"      
            @click="warningDialog = true"
          >
            Update
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="warningDialog"
      persistent
      max-width="500"
    >
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        title="Nett Pay"
        text="Update Nett Pay"
        class="mb-0"
        :loading="loading"
      > 
        <form v-if="warningDialog && !loading">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                class="pb-0"
              >
                This action will <span class="font-weight-medium">NOT re-compute</span> the selected employee's payroll. Do you want to proceed?
              </v-col> 
            </v-row>
          </v-container>
        </form>

        <v-card-actions v-if="warningDialog && !loading">
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="warningDialog = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="progressing"
            color="warning"    
            class="white--text px-10"      
            @click="submitForm"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </material-card>   
    </v-dialog>
  </div>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      nettPay: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localNettPay: null,
        loading: false,
        warningDialog: false,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        this.localNettPay = { ...this.nettPay }

        if (this.localNettPay.current_cycle_net_salary) { this.localNettPay.current_cycle_net_salary = (Math.round((this.localNettPay.current_cycle_net_salary / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.computationBasicSalary().updateNettPay(this.nettPay.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                  this.warningDialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          current_cycle_net_salary: this.localNettPay.current_cycle_net_salary.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>
